module.exports = __webpack_public_path__ + "img/direktabrechnung-aktiv.0d50ceb8.svg";